( function() {
	// Create an intersection observer instance
	const observer = new IntersectionObserver( ( entries, observer ) => {
		entries.forEach(
			entry => {
				if ( entry.isIntersecting ) {
					// Add animate class to child nodes
					if ( entry.target.classList.contains( 'animate-group' ) ) {
						const entryChildren = entry.target.children;

						Array.from( entryChildren ).forEach( ( element, index ) => {
							setTimeout( () => {
								element.classList.add( 'animated' );
							}, index * 200 );	
						} );
					} else {
						entry.target.classList.add( 'animated' );
					}
				}
			}
		);
	}, {
		threshold: 0,
		rootMargin: '-64px',
	} );

	// The elements to be observed
	const animatingElements = document.querySelectorAll( '.animate, .animate-group' );

	// Start observing each element
	animatingElements.forEach(
		animatingElement => {
			observer.observe( animatingElement );
		}
	);

} )();
